import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  sessionDemoEarnings: {
    display: "flex",
    flexDirection: "column",
    height: "fit-content",
    width: "36%",
    alignItems: "center",
    marginTop: "30px",
  },
  count: {
    minWidth: "148px",
    height: "38px",
    marginTop: "1.5rem",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "32px",
    lineHeight: "38px",
    textAlign: "center",
    color: "#3D3D3D",
  },
  data: {
    width: "100px",
    marginTop: "1.5rem",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "16px",
    textAlign: "center",
    color: "#7A7A7A",
  },
  accessFile: {
    display: "flex",
    flexDirection: "row",
    padding: "2px",
    marginLeft: "2.8%",
    marginTop: "2%",
    cursor: "pointer",
  },
  fileName: {
    height: "17px",
    marginLeft: "2.2%",
    marginTop: "1.8%",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "19px",
    letterSpacing: "0.004em",
    textTransform: "capitalize",
    color: "#7A7A7A",
  },
}));

export const MentorSessionsAndEarnings = ({ props }) => {
  const classes = useStyles();

  return (
    <div className={classes.sessionDemoEarnings}>
      <img src={props.img} width="50px" height="50px" />
      <Typography className={classes.count}>{props.count}</Typography>
      <Typography className={classes.data}>{props.data}</Typography>
    </div>
  );
};

export const QuickAccessFiles = ({ props, pdf, mp4Icon }) => {
  const classes = useStyles();

  const viewFile = () => {
    window.open(`${props.resourceUrl}`, "_blank");
  };
  return (
    <>
      <div onClick={viewFile} className={classes.accessFile}>
        {props.type == "doc" ? (
          <img src={pdf} width="25px" height="35px" />
        ) : (
          <img src={mp4Icon} width="25px" height="35px" />
        )}
        <Typography className={classes.fileName}>
          {props.resourceTitle}
        </Typography>
      </div>
    </>
  );
};
